import { render, staticRenderFns } from "./StatementItemDetailsTableItem.vue?vue&type=template&id=4ab12837&scoped=true&"
import script from "./StatementItemDetailsTableItem.vue?vue&type=script&lang=ts&"
export * from "./StatementItemDetailsTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./StatementItemDetailsTableItem.vue?vue&type=style&index=0&id=4ab12837&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab12837",
  null
  
)

export default component.exports